module.exports = __webpack_public_path__ + "static/media/kwsp_logo.e6d1fb83.png";